const STATUS_ITEMS = [
  { id: 1, label: "Checked Out", bgcolor: "#EEF0F9", labelColor: "#5F6477" },
  { id: 2, label: "Enroute", bgcolor: "#FFEDD5", labelColor: "#C2410C" },
  { id: 3, label: "On Site", bgcolor: "#DCFCE7", labelColor: "#15803D" },
  { id: 4, label: "Getting Parts", bgcolor: "#F3E8FF", labelColor: "#7E22CE" },
];

const TechnicianStatus = ({ status }) => {
  const parsedStatus = Number(status);
  let activeItem = STATUS_ITEMS.find((item) => item.id === parsedStatus);

  if (!activeItem) activeItem = STATUS_ITEMS[0];

  return (
    <div
      style={{ backgroundColor: activeItem.bgcolor, color: activeItem.labelColor }}
      className="px-[8px] h-[22px] flex items-center justify-center rounded-[10px] font-OpenSansBold text-[11px] text-titleColor"
    >
      {activeItem.label}
    </div>
  );
};

export default TechnicianStatus;
